import { render, staticRenderFns } from "./NoSegments.vue?vue&type=template&id=26f52ffe&scoped=true&"
var script = {}
import style0 from "./NoSegments.vue?vue&type=style&index=0&id=26f52ffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f52ffe",
  null
  
)

export default component.exports